import React, { useContext, useMemo } from 'react';
import type { Expression } from 'flow/store/engine/types';
import ExpressionBuilderDropdown from '../ExpressionBuilderDropdown';
import { RuleEditorContext } from '../../NodeEditorDrawer/context';
import { RuleEditorDropdownMode } from '../../NodeEditorDrawer/types';
import ExpressionLineItem from './ExpressionLineItem';
import MorphingCaret from '../MorphingCaret';

function AttributeExpressionGroup({
  editable,
  expressions,
  expressionPath = '',
}: {
  editable: boolean;
  expressions: Expression;
  expressionPath?: string;
}) {
  const {
    semanticLineBreakData,
  } = useContext(RuleEditorContext);

  const FirstMorphingCaret = useMemo(() => (
    <MorphingCaret position="-1">
      <ExpressionBuilderDropdown
        expressions={expressions}
        expressionPath={expressionPath}
        mode={RuleEditorDropdownMode.CARET_EXPRESSION}
      />
    </MorphingCaret>
  ), [expressionPath, expressions]);

  return expressions?.length > 0 ? (
    <>
      {editable && FirstMorphingCaret}
      {semanticLineBreakData?.groupedByLines.map((lineData, lineIndex) => (
        <ExpressionLineItem
          key={lineData.id}
          lineIndex={lineIndex}
          expressions={expressions}
        />
      ))}
    </>
  )
    : !expressionPath && editable && FirstMorphingCaret;
}

export default AttributeExpressionGroup;
